// =============================================================================
// analytics-colors - experience series colors shared by the Analyse page and
// the Toppers page, so an experience has the same color on both.
// =============================================================================

// Name of the per-venue counter-sales row of an older function deploy.
export const COUNTER_NAME = 'Balie (pin)';

// Fixed color per series name, for every name the data can currently produce
// (owner's choice 2026-08-27: Egypt oranje, Odyssey/"Voyage" blauw, Maya
// groen; Vouchers must not be green). Pinning ALL of them matters: the
// fallback below hands out the remaining PALETTE slots in alphabetical order
// of the names present in the CURRENT period, so an unpinned series changes
// color whenever a sibling is absent (Vouchers took Maya's orange in weeks
// without Maya). Mid-dark tones so labels stay legible on the white surface.
export const PINNED_COLORS: Record<string, string> = {
  Egypt: '#ea580c',        // oranje
  Odyssey: '#1d4ed8',      // blauw
  Maya: '#15803d',         // groen
  NAP: '#60a5fa',          // lichtblauw (owner's choice 2026-11-05): the indigo fallback read as Odyssey
  Vouchers: '#db2777',     // magenta: far from oranje/blauw/groen (violet read as blue next to Odyssey)
  NextGallery: '#0f766e',  // teal (YTD history only)
  [COUNTER_NAME]: '#6b7280', // grijs: counter sales with no known experience
};

// Fallback slots for a series that is not pinned yet (a newly launched
// experience). Deliberately none of the pinned hues above.
export const PALETTE = ['#4338ca', '#3f6212', '#a21caf', '#0369a1', '#7c2d12', '#525252'];

// Stable color per experience name: pinned brand colors first, then the
// remaining slots in alphabetical order, NOT by current rank, so switching
// metric or period never repaints a survivor.
export function experienceColorOf(names: Iterable<string>): (name: string) => string {
  const map = new Map<string, string>(Object.entries(PINNED_COLORS));
  const pinned = new Set(Object.values(PINNED_COLORS));
  const free = PALETTE.filter((c) => !pinned.has(c));
  [...new Set(names)]
    .filter((n) => !map.has(n))
    .sort((a, b) => a.localeCompare(b, 'nl'))
    .forEach((n, i) => map.set(n, free[i % free.length]!));
  return (name: string) => map.get(name) ?? '#999999';
}
